/* VICCA PRODUCT OPTIONS UI — V2 UX 2026-09-22
   Mejora visual progresiva. Conserva Shopify.OptionSelectors y el flujo de carrito del tema. */
(function () {
  'use strict';

  function moneyDelta(cents) {
    var amount = Math.abs(Math.round((Number(cents) || 0) / 100));
    try {
      return new Intl.NumberFormat('es-CL', { maximumFractionDigits: 0 }).format(amount);
    } catch (e) {
      return String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  }

  function optionName(group) {
    var title = group.querySelector('.title_variant');
    return title ? title.textContent.trim() : '';
  }

  function escapeHtml(value) {
    var span = document.createElement('span');
    span.textContent = String(value == null ? '' : value);
    return span.innerHTML;
  }

  function compactSummaryValue(value) {
    var text = String(value == null ? '' : value).trim();
    return text.replace(/\s*\([^)]*\)\s*$/, '').trim() || text;
  }

  function refineLongLabel(input, choice, isColor) {
    if (isColor || !input || !choice) return;
    var label = choice.querySelector('.vicca-choice__label');
    if (!label) return;

    var value = String(input.value || '').trim();
    var match = value.match(/^(.+?)\s*\((.+)\)\s*$/);

    if (match) {
      label.textContent = '';
      var main = document.createElement('span');
      main.className = 'vicca-choice__main';
      main.textContent = match[1].trim();

      var detail = document.createElement('span');
      detail.className = 'vicca-choice__detail';
      detail.textContent = match[2].trim();

      label.appendChild(main);
      label.appendChild(detail);
      choice.classList.add('vicca-choice--has-detail');
    } else if (value.length >= 42) {
      choice.classList.add('vicca-choice--very-long');
    }
  }

  function init(root) {
    if (!root || root.dataset.viccaEnhanced === 'true') return;

    var jsonNode = root.querySelector('.vicca-product-options__json');
    if (!jsonNode) return;

    var product;
    try {
      product = JSON.parse(jsonNode.textContent);
    } catch (e) {
      return;
    }
    if (!product || !Array.isArray(product.variants)) return;

    root.dataset.viccaEnhanced = 'true';

    var swatches = Array.prototype.slice.call(root.querySelectorAll('.swatch[data-option-index]'));
    if (!swatches.length) return;

    var groups = swatches.map(function (group) {
      var index = Number(group.getAttribute('data-option-index'));
      var inputs = Array.prototype.slice.call(group.querySelectorAll('input[type="radio"]'));
      var name = optionName(group);
      var maxLen = inputs.reduce(function (m, input) {
        return Math.max(m, (input.value || '').length);
      }, 0);
      var isColor = /color|colour/i.test(name);
      var isLong = /medida|dimensi|profundidad|ancho|largo/i.test(name) || maxLen >= 28;
      var count = inputs.length;

      group.classList.add('vicca-option-group');
      group.classList.add('vicca-option-group--count-' + count);
      group.classList.add(count > 8 ? 'vicca-option-group--many' : (count > 4 ? 'vicca-option-group--medium' : 'vicca-option-group--compact'));
      if (isColor) group.classList.add('vicca-option-group--color');
      if (isLong) group.classList.add('vicca-option-group--long');
      if (maxLen > 18) group.classList.add('vicca-option-group--wide-text');

      var cols = isLong ? Math.min(count, 2) : Math.min(count, count > 8 ? 3 : 4);
      group.style.setProperty('--vicca-option-columns', String(Math.max(cols, 1)));

      inputs.forEach(function (input) {
        var choice = input.closest('.maxus-color');
        if (!choice) return;

        choice.classList.add('vicca-choice');
        choice.setAttribute('data-vicca-value', input.value || '');

        if (isColor && !choice.querySelector('.vicca-color-name')) {
          var nameEl = document.createElement('span');
          nameEl.className = 'vicca-color-name';
          nameEl.textContent = input.value || '';
          choice.appendChild(nameEl);
        }

        refineLongLabel(input, choice, isColor);

        var delta = choice.querySelector('.vicca-choice__delta');
        if (!delta) {
          delta = document.createElement('span');
          delta.className = 'vicca-choice__delta';
          if (!isColor) {
            var label = choice.querySelector('.variant_other');
            if (label) label.appendChild(delta);
            else choice.appendChild(delta);
          } else {
            choice.appendChild(delta);
          }
        }

        if (isColor) {
          choice.addEventListener('click', function (event) {
            if (event.target === input) return;
            if (!input.disabled) input.click();
          });
        }
      });

      return { el: group, index: index, name: name, inputs: inputs, isColor: isColor };
    });

    var variantSelect = root.querySelector('#productSelect');

    function variantById(id) {
      var sid = String(id || '');
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === sid) return product.variants[i];
      }
      return null;
    }

    function variantByOptions(options) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if (!Array.isArray(v.options) || v.options.length !== options.length) continue;
        var same = true;
        for (var j = 0; j < options.length; j++) {
          if (String(v.options[j]) !== String(options[j])) {
            same = false;
            break;
          }
        }
        if (same) return v;
      }
      return null;
    }

    function currentVariant() {
      if (variantSelect && variantSelect.value) {
        var fromSelect = variantById(variantSelect.value);
        if (fromSelect) return fromSelect;
      }

      var values = [];
      groups.forEach(function (g) {
        var checked = g.el.querySelector('input[type="radio"]:checked');
        values[g.index] = checked ? checked.value : null;
      });

      if (values.length && values.every(function (v) {
        return v !== null && typeof v !== 'undefined';
      })) {
        return variantByOptions(values);
      }
      return null;
    }

    function ensureSummary() {
      if (groups.length < 2) return null;
      var summary = root.querySelector('.vicca-option-summary');
      if (!summary) {
        summary = document.createElement('div');
        summary.className = 'vicca-option-summary';
        summary.setAttribute('aria-live', 'polite');
        var swatchesWrap = root.querySelector('.product-swatches');
        if (swatchesWrap) swatchesWrap.insertAdjacentElement('afterend', summary);
      }
      return summary;
    }

    function ensurePriceNote() {
      var prices = product.variants.map(function (v) { return Number(v.price) || 0; });
      var hasPriceVariation = prices.some(function (p) { return p !== prices[0]; });
      if (!hasPriceVariation || root.querySelector('.vicca-option-price-note')) return;

      var note = document.createElement('div');
      note.className = 'vicca-option-price-note';
      note.textContent = 'El precio se actualiza automáticamente según la configuración elegida.';

      var summary = ensureSummary();
      if (summary) summary.insertAdjacentElement('afterend', note);
      else {
        var swatchesWrap = root.querySelector('.product-swatches');
        if (swatchesWrap) swatchesWrap.insertAdjacentElement('afterend', note);
      }
    }

    function refresh() {
      var current = currentVariant();
      if (!current || !Array.isArray(current.options)) return;

      groups.forEach(function (g) {
        g.inputs.forEach(function (input) {
          var choice = input.closest('.vicca-choice');
          if (!choice) return;

          var selected = String(current.options[g.index]) === String(input.value);
          choice.classList.toggle('is-selected', selected);
          if (selected && !input.checked) input.checked = true;

          var deltaEl = choice.querySelector('.vicca-choice__delta');
          if (!deltaEl) return;

          if (selected) {
            choice.classList.remove('is-unavailable', 'is-saving');
            deltaEl.classList.remove('is-saving');
            deltaEl.textContent = 'Seleccionada';
            return;
          }

          var candidateOptions = current.options.slice();
          candidateOptions[g.index] = input.value;
          var candidate = variantByOptions(candidateOptions);

          if (!candidate) {
            choice.classList.add('is-unavailable');
            deltaEl.textContent = 'No disponible con esta configuración';
            return;
          }

          if (candidate.available === false) {
            choice.classList.add('is-unavailable');
            deltaEl.textContent = 'Agotada';
            return;
          }

          choice.classList.remove('is-unavailable', 'is-saving');
          deltaEl.classList.remove('is-saving');

          var diff = (Number(candidate.price) || 0) - (Number(current.price) || 0);
          if (diff > 0) {
            deltaEl.textContent = '+$' + moneyDelta(diff);
          } else if (diff < 0) {
            deltaEl.textContent = '$' + moneyDelta(diff) + ' menos';
            deltaEl.classList.add('is-saving');
            choice.classList.add('is-saving');
          } else {
            deltaEl.textContent = 'Sin costo adicional';
          }
        });
      });

      var summary = ensureSummary();
      if (summary) {
        summary.innerHTML = '<strong>Tu configuración:</strong> ' +
          current.options.map(function (value) {
            return escapeHtml(compactSummaryValue(value));
          }).join(' · ');
      }
    }

    ensurePriceNote();

    root.addEventListener('change', function (event) {
      if (event.target && event.target.matches('input[type="radio"], select')) {
        window.setTimeout(refresh, 20);
        window.setTimeout(refresh, 120);
      }
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        window.setTimeout(refresh, 0);
      });
    }

    window.setTimeout(refresh, 0);
    window.setTimeout(refresh, 120);
    window.setTimeout(refresh, 400);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-vicca-product-options]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.setTimeout(boot, 0);
    });
  } else {
    window.setTimeout(boot, 0);
  }
})();